<template>
    <div class="campaigns-page">
        <ftu-content-box
            :header="$t('campaignsPage.marketplace.ftu.title')"
            :description="$t('campaignsPage.marketplace.ftu.description')"
            feature="marketplace"
        />

        <section class="page-content">
            <DsTabset>
                <DsTab
                    data-qa="campaigns-active-tab"
                    :label="$t('campaignsPage.tabs.active')"
                    selected
                    :action="() => currentTab = 'active'"
                />
                <DsTab
                    data-qa="campaigns-archived-tab"
                    :label="$t('campaignsPage.tabs.archived')"
                    :action="() => currentTab = 'archived'"
                />
            </DsTabset>

            <div class="filter">
                <div class="metric light">
                    <span v-if="isLoaded">
                        <h2 class="regular">{{ totalCampaigns }}</h2> {{ $t('campaignsPage.totalCampaignsLabel') }}
                    </span>
                </div>

                <search-bar
                    v-model.trim="searchText"
                    :placeholder="$t('campaignsPage.search.placeholder')"
                />
            </div>
            <campaigns-table
                :search-text="searchText"
                :archived="currentTab === 'archived'"
                @resetFilters="resetFilters"
                @dataLoading="pagePerf_signalDataLoadStart"
                @dataLoaded="tableDataLoaded"
            />
        </section>
    </div>
</template>

<script>
import dateUtils from '@/mixins/date-utils';
import pagePerformance from '@/mixins/page-performance';

import CampaignsTable from './components/CampaignsTable';
import FtuContentBox from 'components/Ftu/FtuContentBox';
import SearchBar from 'components/SearchBar/SearchBar';
import { mapState } from 'vuex';

export default {
    components: {
        CampaignsTable,
        FtuContentBox,
        SearchBar,
    },

    mixins: [dateUtils, pagePerformance],

    data() {
        return {
            searchText: '',
            mpCompaniesRetrieved: false,
            currentTab: 'active',
        };
    },

    computed: {
        ...mapState({
            isLoaded: ({ api }) => api.campaigns.fetch.isLoaded,
            totalCampaigns: ({ api }) => api.campaigns.fetch.meta.totalElements,
        }),
    },

    methods: {
        resetFilters() {
            this.searchText = '';
        },

        tableDataLoaded({ resultCount: campaignCount }) {
            return this.pagePerf_signalDataLoadEnd(campaignCount);
        },
    },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    .campaigns-page {
        @include container(calc($spacing-200 * 1.2), 100%);
    }

    .filter {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        margin-top: $spacing-400;

        .showing {
            margin: 0;
        }

        .search-container {
            margin-bottom: $spacing-300;
            width: px-to-rem(280px);

            @media($small) {
                width: 100%;
            }
        }

        @media($small) {
            flex-direction: column;
            padding: 0 $spacing-200;
            width: 100%;
        }
    }

    .filter-medium {
        @media ($medium) {
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            .filter {
                width: 100%;
            }
        }
    }

    .metric {
        margin-right: $spacing-400;
        color: $color-gray;

        h2 {
            color: $color-gray;
        }

        * {
            display: inline-block;
        }
    }

    .page-content {
        margin-bottom: $spacing-800;
    }
</style>
